// extracted by mini-css-extract-plugin
module.exports = {"mobile-search":"_32thM","mobileSearch":"_32thM","inner":"_2yoL8","top-section":"_1hYbB","topSection":"_1hYbB","open":"DF_ij","topics-title":"_1e5Zp","topicsTitle":"_1e5Zp"};